import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AiToneOfVoicesQuery,
  UpdateAiToneOfVoiceMutation,
  UpdateAiToneOfVoiceMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const updateAiToneOfVoice = graphql(`
  mutation updateAiToneOfVoice($input: UpdateAiToneOfVoiceRequest!) {
    updateAiToneOfVoice(input: $input) {
      id
      label
      rawValue
      isDefault
      companyId
      teamId
      createdAt
      updatedAt
      sourceDocumentId
    }
  }
`);

export function useUpdateAiToneOfVoice(
  options?: UseMutationOptions<
    UpdateAiToneOfVoiceMutation,
    unknown,
    UpdateAiToneOfVoiceMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(updateAiToneOfVoice, {
    ...options,
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);

      // If the default status was changed, refetch the whole list to ensure one default will appear
      if (variables.input.isDefault !== undefined) {
        await queryClient.invalidateQueries({ queryKey: ["aiToneOfVoices"] });
      } else {
        const updated = data.updateAiToneOfVoice;
        queryClient.setQueryData(["aiToneOfVoices"], (prev: AiToneOfVoicesQuery | undefined) => {
          if (!prev) return prev;
          return {
            aiToneOfVoices: {
              results: prev.aiToneOfVoices.results.map((t) =>
                t.id === updated.id ? { ...t, ...updated } : t,
              ),
            },
          };
        });
      }
    },
  });

  return { data: data?.updateAiToneOfVoice, ...rest };
}
